<template>
  <BuilderWrapper
    title="Summary Table"
    helpful-tip="The summary table is an optional feature that shows aggregated data in the left hand side panel."
    :show-premium-feature="!featureEnabled"
    :expand-disabled="!featureEnabled"
  >
    <template v-if="featureEnabled">
      <LabelledInput>
        <b-checkbox v-model="showSummaryTable">
          Show summary table
        </b-checkbox>
      </LabelledInput>

      <template v-if="showSummaryTable && !exclude.includes('settings')">
        <SelectDisplay />
        <SelectFields />
        <SelectOptions />
      </template>
    </template>
  </BuilderWrapper>
</template>

<script lang="ts">

import { PropType } from 'vue'
import Component from 'vue-class-component'

import BuilderWrapper from '@/components/builder/UI/BuilderWrapper.vue'
import LabelledInput from '@/components/builder/UI/LabelledInput.vue'
import SelectFields from '@/components/builder/SummaryTableSettings/SelectFields.vue'
import SelectDisplay from '@/components/builder/SummaryTableSettings/SelectDisplay.vue'
import SelectOptions from '@/components/builder/SummaryTableSettings/SelectOptions.vue'
import FeatureSetMixin from '@/mixins/FeatureSetMixin'
import { FeatureKeys } from '@/types'
import { APP_CONFIG_KEY } from '@/constants'

const components = {
  BuilderWrapper,
  SelectFields,
  SelectDisplay,
  SelectOptions,
  LabelledInput,
}

const props = {
  exclude: {
    type: Array as PropType<string[]>,
    default: () => [],
  },
}

@Component({ components })
export default class SummaryTableSettings extends FeatureSetMixin.extend({ props }) {
  featureKey = FeatureKeys.SUMMARY_TABLE
  featureEnabled!: boolean

  get showSummaryTable () {
    return this.$typedStore.primary.app.config[APP_CONFIG_KEY].showSummaryTable
  }

  set showSummaryTable (value: boolean) {
    this.$typedStore.primary.app.updateConfig({
      configPath: [APP_CONFIG_KEY, 'showSummaryTable'],
      value,
    })
  }
}

</script>
